import { render, staticRenderFns } from "./EnrollmentDetails.vue?vue&type=template&id=126e631b&scoped=true"
import script from "./EnrollmentDetails.vue?vue&type=script&lang=js"
export * from "./EnrollmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentDetails.vue?vue&type=style&index=0&id=126e631b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e631b",
  null
  
)

export default component.exports